import React from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkPermission, checkTranslation } from "../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";

class ItemModal extends React.Component {


    state = {

    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.headers != this.props.headers) {
            this.init()
        }
    }

    init() {
        this.setState({ headers: this.props.headers, activePage: null })
    }

    submitForm = () => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.props.submitForm({...data})
            }
        } else {
            this.postValue()
        }
    }
    hideModal = () => {
        this.modal.hideModal()
    }

    state = {
        countries: [],
        actions: {
            submit: { key: "submit", label: "{{lang}}submit", bgColor: '#677dc4', color: '#fff', function: this.submitForm, loader: "isPostingData" },
            cancel: { key: "cancel", label: "{{lang}}cancel", bgColor: '#9ab', color: '#fff', function: this.hideModal },
        }
    }




    postValue = () => {
        // console.log("postValue")
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page

            // console.log(data)
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.page ? this.props.page?.page : this.props.page?.key
                this.setState({ isPostingData: true })

                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }

                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                console.log(address)


                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    console.log(fetchError)
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.modal.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Sent Succesfully', description: '{{lang}}Send Record Succesfully' })
                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info, this.props.modalIndex)
                    }

                    if (isEditing && this.props.itemEdited) {
                        // console.log("itemEdited")
                        // console.log(data)
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id, this.props.modalIndex)
                        } else {
                            this.props.itemEdited(data, data._id, this.props.modalIndex)
                        }
                    }
                })
            }
        }
    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }

    itemAdded = () => { }

    itemEdited = () => { }


    render() {
        return (

            <Modal ref={el => this.modal = el} maxWidth={800}>
                <div className="pb-5 w-100 h-100">

                    {this.props.showDates && this.props?.initData?._id && (
                        <div className="flexc  px-2">
                            <p className="text-small" style={{ color: '#00000050' }}>Create Date: {moment(this.props.initData?.cDate).format('YYYY MMMM DD')}</p>
                            <p className="text-small mld-4" style={{ color: '#00000050' }}>Udpate Date: {moment(this.props.initData?.uDate).format('YYYY MMMM DD')}</p>
                        </div>
                    )}
                    <p className="text-small mb-2  px-2" style={{ color: '#00000050' }}>{this.props.initData?._id}</p>


                    <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                        <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                            <div>
                                <p>{(this.props.title ?? (this.props?.initData?._id ? "Edit" : "Add"))}</p>

                            </div>
                            <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                            </div>

                        </div>
                        {/* <div className="px-4 py-2">
                            <p className="text-small" style={{color:'#789'}}>Create Date: {moment(this.props.initData?.cDate).format('YYYY MMMM DD')}</p>
                            <p className="text-small" style={{color:'#789'}}>Udpate Date: {moment(this.props.initData?.uDate).format('YYYY MMMM DD')}</p>

                        </div> */}
                        {this.props.page?.pages && (
                            <div className="w-100 flexc mb-2">

                                <div className="ml-0 text-center" onClick={() => { this.changePage(null) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.activePage == null ? '#677dc4' : '#9ab', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                    <p>Details</p>
                                </div>

                                {this.props.page.pages.map((prop, index) => {
                                    return (
                                        <div className="ml-0 text-center" onClick={() => { this.changePage(index, prop) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', borderLeft: '1px solid #89a', transition: 'all 0.3s', backgroundColor: this.state.activePage == index ? (prop.tabColor ?? '#677dc4') : '#9ab', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                            <p>{prop.title}</p>
                                        </div>)
                                })}

                            </div>
                        )}

                        {!this.state.hideForm && (
                            <div className="py-3 px-4">
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                            </div>
                        )}


                        <div className="flexc px-3 pb-3">
                            {Object.values(this.state.actions).map((prop, index) => {
                                if (prop.key != 'submit' || (!this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.create')) || (this.props.initData?._id && checkPermission(this.props.variables?.permissionRoot + '.edit')))
                                    return (
                                        <div key={index} className="w-100 mx-1">

                                            <LoaderButton
                                                onClick={prop.function}
                                                isLoading={this.props[prop.loader] ?? this.state[prop.loader]}
                                                text={checkTranslation(prop.label)}
                                                type={"Oval"}
                                                className="text-bold text-small text-uppercase w-100"
                                                buttonStyle={{ outline: 'none', width: '100%', backgroundColor: prop.bgColor, cursor: 'pointer', padding: '13px 20px', borderRadius: 8, textTransform: 'uppercase', fontSize: 15, fontWeight: 'bold', color: prop.color, border: 'none' }}
                                                width={40}
                                                height={40}
                                                color={prop.bgColor}
                                            />
                                        </div>
                                    )
                            })}
                        </div>
                    </div>


                </div>
            </Modal>
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(ItemModal);
